export default __webpack_public_path__ + "static/media/41.bc2f6985.jpg";